"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _disposable = require("./helpers/disposable");

var _glTexture2d = require("gl-texture2d");

var _glTexture2d2 = _interopRequireDefault(_glTexture2d);

var _TextureLoader2 = require("./TextureLoader");

var _TextureLoader3 = _interopRequireDefault(_TextureLoader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var identity = function identity(a) {
  return a;
};

var Texture2DLoader = function (_TextureLoader) {
  _inherits(Texture2DLoader, _TextureLoader);

  function Texture2DLoader(gl) {
    _classCallCheck(this, Texture2DLoader);

    var _this = _possibleConstructorReturn(this, (Texture2DLoader.__proto__ || Object.getPrototypeOf(Texture2DLoader)).call(this, gl));

    _this.textures = new WeakMap();
    // (^ we assume you have included polyfill like babel-polyfill if you want to support older browsers)
    return _this;
  }

  _createClass(Texture2DLoader, [{
    key: "dispose",
    value: function dispose() {
      (0, _disposable.disposeObjectMap)(this.textures);
    }
  }, {
    key: "get",
    value: function get(t) {
      var inferShape = this.inferShape;

      var texture = this.textures.get(t);
      var shape = inferShape ? inferShape(t) : null;
      if (shape && (!shape[0] || !shape[1])) return null; // not yet ready
      var mapTexture = this.mapTexture || identity;
      if (!texture) {
        texture = (0, _glTexture2d2.default)(this.gl, shape ? shape : mapTexture(t));
        this.textures.set(t, texture);
      }
      if (shape && (shape[0] !== texture.shape[0] || shape[1] !== texture.shape[1])) {
        texture.shape = shape;
      }
      // we assume we always have to sync canvas texture
      texture.setPixels(mapTexture(t));
      return texture;
    }
  }]);

  return Texture2DLoader;
}(_TextureLoader3.default);

exports.default = Texture2DLoader;
//# sourceMappingURL=Texture2DLoader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react/lib/Texture2DLoader.js
// module id = 77
// module chunks = 0